/**
 * PROJECT INFO (DERIVED PROJECT IDENTITY round — Matt: "the project name,
 * address, project number, client, etc. should be derived from the project the
 * concept is in. Manual entry defeats the purpose of a connected database.")
 *
 * The Airtable project's identity fields, MIRRORED into the model doc on every
 * editable open (ModelerPage's mirror effect — the LINKED SHEETS round's
 * mirror-at-source pattern): Airtable stays the source of truth, the doc carries
 * a copy so the title strip / site settings / PDF export read it synchronously,
 * offline, and identically on every peer. Never hand-edited in the Modeler —
 * fix the project record and reopen.
 *
 * One settings-map key, the siteSettings pattern.
 */
import type { ModelDoc } from './doc'
import { maps, transact } from './doc'

const PROJECT_INFO_KEY = 'projectInfo'

export interface ProjectInfo {
  /** Airtable `Project Name` */
  name: string
  /** Airtable `Project Number` (e.g. "26-14") */
  number: string
  /** Airtable `Client Name` lookup — the client's display name */
  client: string
  /** Airtable `Project Street Address` */
  street: string
  /** "City, ST Zip" composed from the project's city/state/zip fields */
  cityStateZip: string
}

export function getProjectInfo(model: ModelDoc): ProjectInfo {
  const v = maps(model).settings.get(PROJECT_INFO_KEY) as Partial<ProjectInfo> | undefined
  const s = (x: unknown) => (typeof x === 'string' ? x : '')
  return {
    name: s(v?.name), number: s(v?.number), client: s(v?.client),
    street: s(v?.street), cityStateZip: s(v?.cityStateZip),
  }
}

export function setProjectInfo(model: ModelDoc, patch: Partial<ProjectInfo>): void {
  transact(model, () => {
    maps(model).settings.set(PROJECT_INFO_KEY, { ...getProjectInfo(model), ...patch })
  })
}

/** the full mailing-style address ("street, City, ST Zip"), '' when nothing known */
export function projectAddress(info: ProjectInfo): string {
  return [info.street, info.cityStateZip].filter(Boolean).join(', ')
}
